export const SELF_SHOWING_LOCK_TYPE_SUNLOCK = 'sunlock';
export const SELF_SHOWING_LOCK_TYPE_IGLOOHOMELOCK = 'igloohome';
export const SELF_SHOWING_LOCK_TYPE_CODEBOX = 'codebox';

export const SELF_SHOWING_LOCK_ACTION_ASSIGN = 'assing';
export const SELF_SHOWING_LOCK_ACTION_UNASSIGN = 'unassing';

export const SELF_SHOWING_LOCK_ACTIONS_LIST = [
  SELF_SHOWING_LOCK_ACTION_ASSIGN,
  SELF_SHOWING_LOCK_ACTION_UNASSIGN,
];

export const SELF_SHOWING_LOCK_CODEBOX_REQUESTS_ALERT_THRESHOLD = 12;

export const SELF_SHOWING_ISSUE_TYPE_INCORRECT_CODE = 'incorrectCode';
export const SELF_SHOWING_ISSUE_TYPE_DOOR_LOCKED = 'doorLocked';
export const SELF_SHOWING_ISSUE_TYPE_KEY_NOT_IN_LOCKBOX = 'keyNotInLockbox';
export const SELF_SHOWING_ISSUE_TYPE_LOCKBOX_NOT_WORKING = 'lockboxNotWorking';
export const SELF_SHOWING_ISSUE_TYPE_OTHER = 'other';

export const SELF_SHOWING_ISSUE_TYPES = [
  SELF_SHOWING_ISSUE_TYPE_INCORRECT_CODE,
  SELF_SHOWING_ISSUE_TYPE_DOOR_LOCKED,
  SELF_SHOWING_ISSUE_TYPE_KEY_NOT_IN_LOCKBOX,
  SELF_SHOWING_ISSUE_TYPE_LOCKBOX_NOT_WORKING,
  SELF_SHOWING_ISSUE_TYPE_OTHER,
];
